// PublicRoute.jsx
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  selectAuthStatus,
  selectIsAuthenticated,
} from "../../../store/src/slices/auth-slice";

import Loader from "../loader";

const PublicRoute = ({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const authStatus = useSelector(selectAuthStatus);

  if (authStatus === "loading") {
    return <Loader />;
  }

  return isAuthenticated ? <Navigate to="/" replace /> : children;
};

export default PublicRoute;
